<style src="./style.scss">
</style>

<script lang="ts">
  import { afterUpdate } from "svelte";

  import Icon from "svelte-icon";
  import CloseIcon from "@assets/icons/close.svg";

  export let isOpen;
  export let title;
  export let onClose = () => null;
  export let showCloseButton = true;

  let closeModalAnimationClassName = "";

  const disabledScrollPage = () => {
    document.body.style.overflow = "hidden";
  };

  const enableScrollPage = () => {
    document.body.style.overflow = "auto";
  };

  afterUpdate(() => {
    isOpen ? disabledScrollPage() : enableScrollPage();
  });

  document.onkeydown = function (evt) {
    if (!showCloseButton) {
      return false;
    }

    evt = evt || window.event;
    var isEscape = false;
    if ("key" in evt) {
      isEscape = evt.key === "Escape" || evt.key === "Esc";
    } else {
      isEscape = evt.keyCode === 27;
    }
    if (isEscape) {
      closeModalTimeout();
    }
  };

  function closeModalTimeout() {
    closeModalAnimationClassName = "__hide";
    setTimeout(() => {
      onClose();
      closeModalAnimationClassName = "";
    }, 300);
  }
</script>

{#if isOpen}
  <div
    class="{`modal overlay${
      isOpen && closeModalAnimationClassName === '' ? '__show' : ''
    }${closeModalAnimationClassName}`}">
    <div class="modal__content">
      <div class="modal__header">
        {title}
        {#if showCloseButton}
          <div on:click="{closeModalTimeout}">
            <Icon
              data="{CloseIcon}"
              size="16px"
              stroke="transparent"
              fill="#1a1a1a" />
          </div>
        {/if}
      </div>
      <div class="modal__slot">
        <slot />
      </div>
    </div>
  </div>
{/if}
